import React, { useState } from "react";
import { Link } from "react-router-dom";
import Admissionleft from "./Admissoinleft";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import Fade from "react-bootstrap/Fade";

function MtechInternational_AdmissionELe() {
    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    // const [categoryOpen, setCategoryOpen] = useState(false);
    const [areasOpen, setAreasOpen] = useState(false);
    const [eligiblityOpen, setEligiblityOpen] = useState(false);
    const [financialOpen, setFinancialOpen] = useState(false);
    // const [sectionOpen, setSectionOpen] = useState(false);
    const [documentsOpen, setDocumentsOpen] = useState(false);
    const [feesOpen, setFeesOpen] = useState(false);
    const [applyonlineOpen, setApplyonlineOpen] = useState(false);

    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);
        // setCategoryOpen(false);
        setAreasOpen(false);
        setEligiblityOpen(false);
        setFinancialOpen(false);
        // setSectionOpen(false);
        setDocumentsOpen(false);
        setFeesOpen(false);
        setApplyonlineOpen(false);
        event(true);
    };

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className="c-left custom-padding-color mb-5">
                        <Admissionleft activeIndex={7} />
                    </Col>

                    <Col md={8} className="c-right">
                        <div className="c-heading">
                            <h3>Master of Technology International Admissions</h3> <br />
                        </div>

                        <Row className="mb-5">
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button"
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}
                                >
                                    Dates
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setGuidelinesOpen)
                                    }
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}
                                >
                                    Guidelines
                                </Button>
                            </Col>

                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setCategoryOpen)}
                                    aria-controls="c-categoryOpen"
                                    aria-expanded={categoryOpen}
                                >
                                    Categories
                                </Button>
                            </Col> */}

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setAreasOpen)}
                                    aria-controls="c-areas"
                                    aria-expanded={areasOpen}
                                >
                                    Areas
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setEligiblityOpen)
                                    }
                                    aria-controls="c-eligiblity"
                                    aria-expanded={eligiblityOpen}
                                >
                                    Eligiblity
                                </Button>
                            </Col>

                             {/* Fees */}
                             <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setFeesOpen)}
                                    aria-controls="c-feesopen"
                                    aria-expanded={feesOpen}
                                >
                                    Fees
                                </Button>
                            </Col>


                            {/* financial */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setFinancialOpen)
                                    }
                                    aria-controls="c-financial"
                                    aria-expanded={financialOpen}
                                >
                                    Financial Assistance
                                </Button>
                            </Col>
                            {/* section */}
                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setSectionOpen)}
                                    aria-controls="c-fiancial"
                                    aria-expanded={sectionOpen}
                                >
                                    Selection
                                </Button>
                            </Col> */}
                            {/* Documents */}
                           {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setDocumentsOpen)
                                    }
                                    aria-controls="c-document"
                                    aria-expanded={documentsOpen}
                                >
                                    Documents
                                </Button>
                            </Col> */}

                           
                            {/* Apply Online */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setApplyonlineOpen)
                                    }
                                    aria-controls="c-applyonline"
                                    aria-expanded={feesOpen}
                                >
                                    Apply Online
                                </Button>
                            </Col>
                        </Row>

                        {/*dates */}
                        <div>
                            {datesOpen && (
                                <Fade in={datesOpen}>
                                    <div>

                                        {/* <a className="text-maroon glowing-text" href="https://files.iittp.ac.in/pdfs/admissions/international/MTech_Int_Flyer_3_2005.pdf" target="_blank;"><b>M.Tech International Admissions Brochure - Click here </b></a> <br /><br /> */}


                                        <Table
                                            bordered
                                            responsive
                                            className="mt-3"
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan="2"
                                                        className="text-center"
                                                    >
                                                        <h4 className="text-primary">
                                                            Important Dates
                                                        </h4>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                    <td>
                                                    Admission Portal 
                                                    </td>
                                                    <td>
                                                        <b className="c-link glowing-text">Open</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                    Application Review Begins
                                                    </td>
                                                    <td>
                                                        <b className="c-link glowing-text">April 2027</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                    Interview
                                                    </td>
                                                    <td>
                                                        <b className="c-link glowing-text">	May 2027</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Announcement of Results</td>
                                                    <td>
                                                        <b className="c-link glowing-text">Within two weeks from the date of completion of the interview</b>
                                                    </td>
                                                </tr>
                                                                                                <tr>
                                                                                                    <td>Result (July 2027 Intake)</td>
                                                                                                    <td>
                                                                                                       <b className="c-link glowing-text">To be announced</b>
                                                                                                        {/*<b><Link className="c-link" target="_blank" to="https://files.iittp.ac.in/pdfs/admissions/international/MsPhDMtech-International-Jul2026_Intake_Results.pdf">Click Here</Link></b>*/}
                                                                                                    </td>
                                                                                                </tr>
                                                {/* <tr>
                                                    <td>Orientation Program</td>
                                                    <td>
                                                        <b>Friday, July 26, 2024</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Commencement of classes
                                                    </td>
                                                    <td>
                                                        <b>Thursday, August 1, 2024</b>
                                                    </td>
                                                </tr>*/}
                                            </tbody>
                                        </Table>

                                        <b>
                                            Please write to{" "}
                                            <Link
                                                to="mailto:gac_office@iittp.ac.in"
                                                className="c-link"
                                            >
                                                gac_office@iittp.ac.in
                                            </Link>{" "}
                                            or WhatsApp/ mobile at  +91 90300 38191/ 8333 904 912 for any questions or queries regarding admission related matters. {" "}
                                        </b>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Guidelines*/}

                        <div>
                            {guidelinesOpen && (
                                <Fade in={guidelinesOpen}>
                                    <div className="c-lineheight2dot5">
                                        <h4 className="mb-3">
                                            Important Guidelines
                                        </h4>
                                        <ol className="list-group list-group-numbered"
                                            style={{
                                                textAlign: "justify",
                                                fontSize: "12pt",
                                            }}
                                        >
                                            <li>
                                              
                                            The link to the online application form is available under the Apply Online tab. After completing the online form, please save it for your record.
                                            </li>
                                            <li>You can apply to a maximum of three departments.</li>
                                            <li>
                                            The following documents must be uploaded before submitting your application. Each document must be less than 1MB.
                                            </li>

                                            <li>
                                                {" "}
                                                Please be ready with the following documents before upload: : 
                                                <ul className="myulcustarrow">
                                                    <li>A copy of passport or any government issued identity document (as applicable)</li>
                                                    <li>
                                                        Passport size Photo
                                                        (jpg, jpeg, png).
                                                    </li>
                                                    <li>
                                                        Signature (format jpg,
                                                        jpeg, png).
                                                    </li>
                                                    <li>
                                                    School leaving certificate (pdf).
                                                    </li>
                                                    <li>
                                                    UG Degree Certificate (pdf).
                                                    </li>
                                                    <li>
                                                    Consolidated UG transcript (pdf).
                                                    </li>
                                                    {/* <li>
                                                    PG Degree Certificate (if applicable) (pdf) size
                                                        &lt;=1024 KB
                                                    </li> */}
                                                    {/* <li>
                                                    Consolidated PG transcript (pdf) size
                                                        &lt;= 1024 KB
                                                    </li> */}
                                                    <li>
                                                    First page of publication, (if applicable) (pdf, jpg, jpeg).
                                                    </li>
                                                </ul>
                                            </li>
                                        </ol>
                                         {/* <li>
                                            In case of any queries, please
                                            write to{" "}
                                            <a className="c-link" href="mailto:ia_office@iittp.ac.in">
                                            ia_office@iittp.ac.in
                                            </a>{" "}
                                           
                                        </li> */}

                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Categoies*/}

                        {/* <div>
                            {categoryOpen && (
                                <Fade in={categoryOpen}>
                                    <div className="c-lineheight2dot5">
                                        <h4 className="mb-3">
                                            Ph.D admissions are made under two
                                            categories
                                        </h4>

                                        <li>
                                            1. Regular (Full-time scholars): The
                                            research scholars selected under
                                            regular registration will be
                                            eligible for assistantship through
                                            various schemes (please see
                                            Financial Assistance)
                                        </li>
                                        <li>
                                            External:
                                            <ul className="myulcustarrow">
                                                <li>
                                                    The applicants must be
                                                    regular employees and have
                                                    at least two years of work
                                                    experience.
                                                </li>
                                                <li>
                                                    They must be sponsored by
                                                    and employed in an
                                                    industry/organization/national
                                                    laboratories, having R&D
                                                    facilities and recognized by
                                                    DST or by IIT Tirupati.
                                                </li>
                                                <li>
                                                    Research scholars admitted
                                                    under this category will
                                                    normally carry out part or
                                                    all of their research in the
                                                    parent organization under
                                                    supervision of a faculty
                                                    from IIT Tirupati and a
                                                    co-supervisor employed in
                                                    their parent organization.
                                                </li>
                                            </ul>
                                        </li>

                                        <ul className="myulcustarrow">
                                            <li>
                                                The following documents are
                                                required along with the
                                                application{" "}
                                            </li>
                                        </ul>

                                        <ol className="myulcustdisc">
                                            <li>
                                                Proof of employment (Identity
                                                Card or latest salary statement)
                                            </li>
                                            <li>
                                                No-Objection Certificate or
                                                Undertaking (format available at
                                                this{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/3.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                                )
                                            </li>
                                        </ol>

                                        <ul className="myulcustarrow">
                                            <li>
                                                The following documents are
                                                required at the time of
                                                admission
                                            </li>
                                        </ul>

                                        <ol className="myulcustdisc">
                                            <li>
                                                Certificate of Support from the
                                                Employer:{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/4.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                            </li>
                                            <li>
                                                Relieving Certificate from the
                                                Employer:{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/5.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                            </li>
                                        </ol>

                                        <ul className="myulcustarrow">
                                            <li>
                                                More details on this category of
                                                admission, including any
                                                questions regarding the
                                                recognition of the
                                                organization/laboratory might be
                                                addressed to the Head of the
                                                department of interest or{" "}
                                                <Link
                                                    to="mailto:admissions@iittp.ac.in"
                                                    className="c-link"
                                                >
                                                    admissions@iittp.ac.in
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </Fade>
                            )}
                        </div> */}

                        {/*Areas*/}

                        <div>
                            {areasOpen && (
                                <Fade in={areasOpen}>
                                    <div>
                                        <h4 className="mb-4">Areas</h4>
                                        <p>
                                        IIT Tirupati offers M.Tech. programs in the following areas/streams.
                                        </p>

                                        {/* Table */}
                                        <Table
                                            bordered
                                            responsive
                                            className="mt-3 c-table"
                                        >
                                            <colgroup>
                                                {/* <col style={{ width: "20%" }} />{" "} */}
                                                {/* 33% for each column */}
                                                <col style={{ width: "50%" }} />
                                                <col style={{ width: "50%" }} />
                                            </colgroup>
                                            <tbody>
                                                {/* Table header */}
                                                <tr>
                                                    <td>
                                                        <b>Department</b>
                                                    </td>
                                                    <td>
                                                        <b>
                                                            M.Tech. Stream /
                                                            Specialization
                                                        </b>
                                                    </td>
                                                </tr>
                                                {/* Table rows */}
                                                {/* Row 1 */}
                                                <tr>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                </tr>
                                                {/* Row 2 */}
                                                <tr>
                                                    <td rowspan="4" valign="middle">
                                                        Civil and Environmental
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Environmental and Water
                                                        Resources Engineering
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>
                                                        Geotechnical Engineering
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Structural Engineering
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        Transportation and
                                                        Infrastructure
                                                        Engineering
                                                    </td>
                                                </tr>

                                                {/* Row 3 */}
                                                <tr>
                                                    <td>
                                                        Computer Science &amp;
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Computer Science &amp;
                                                        Engineering
                                                    </td>
                                                </tr>

                                                {/* Row 4 */}
                                                <tr>
                                                    <td rowspan="3" valign="middle">
                                                        Electrical Engineering
                                                    </td>
                                                    <td>
                                                        Signal Processing &
                                                        Communications
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        Microelectronics & VLSI
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        RF & Microwave
                                                        Engineering
                                                    </td>
                                                </tr>

                                                {/* Row 5 */}
                                                <tr>
                                                    <td rowspan="2" valign="middle">
                                                        Mechanical Engineering
                                                    </td>
                                                    <td>
                                                        Design & Manufacturing
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Thermal Engineering and
                                                        Energy Systems
                                                    </td>
                                                </tr>

                                                {/* End of table rows */}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Eligiblity*/}

                        <div>
                            {eligiblityOpen && (
                                <Fade in={eligiblityOpen}>
                                    <div>
                                        <h4 className="mb-4">Eligibility</h4>
                                        <p>All International M.Tech applicants must satisfy the following criteria:</p>

                                        <ul className='myulcustarrow'>
                                            <li>
                                            CGPA of 6.5/10 (or equivalent)
                                            </li>
                                            <li>
                                            Proof of English Proficiency – if medium of instruction at the undergraduate level is not English.
                                            </li>
                                            <li>
                                            A 4-year bachelor's degree in relevant engineering discipline.
                                            </li>
                                        </ul>

                                       

                                        {/* <Table
                                            bordered
                                            responsive
                                            className="mt-3"
                                        >
                                            <tbody>
                                                <tr>
                                                    <td rowSpan="2">
                                                        If you have
                                                    </td>
                                                    <td rowSpan="2">
                                                        <b>
                                                            And if you have
                                                            written GATE PAPER
                                                            in
                                                        </b>
                                                    </td>
                                                    <td colSpan="2">
                                                        <b>
                                                            You are eligible to
                                                            apply for M. Tech in
                                                        </b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Department</td>
                                                    <td>
                                                        Stream/Specialization
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        BE/B. Tech degree in any
                                                        discipline
                                                    </td>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Chemical
                                                                Engineering
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan="2" valign="middle">
                                                        BE/B. Tech degree in
                                                        Civil
                                                        Engineering/Environmental
                                                        Science/Environmental
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Civil Engineering /
                                                        Environmental Science
                                                        and Engineering
                                                    </td>
                                                    <td>
                                                        Civil & Environmental
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Environmental
                                                                and Water
                                                                Resources
                                                                Engineering
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Civil Engineering</td>
                                                    <td>
                                                        Civil & Environmental
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Geotechnical
                                                                Engineering
                                                            </li>
                                                            <li>
                                                                Structural
                                                                Engineering
                                                            </li>
                                                            <li>
                                                                Transportation
                                                                and
                                                                Infrastructure
                                                                Engineering
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        BE/B. Tech degree in any
                                                        discipline
                                                    </td>
                                                    <td>
                                                        Computer Science and
                                                        Information Technology
                                                    </td>
                                                    <td>
                                                        Computer Science and
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Computer Science
                                                                and Engineering
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        BE/B. Tech degree in
                                                        Electrical
                                                        Engineering/Electronics
                                                        and Communication
                                                        Engineering/Electrical
                                                        and Electronics
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Electronics and
                                                        Communication
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Electrical Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Signal
                                                                Processing and
                                                                Communications
                                                            </li>
                                                            <li>
                                                                Microelectronics
                                                                and VLSI
                                                            </li>
                                                            <li>
                                                                RF and Microwave
                                                                Engineering
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        BE/B. Tech degree in
                                                        Mechanical
                                                        Engineering/Production
                                                        Engineering/Industrial
                                                        and Production
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Mechanical
                                                        Engineering/Production
                                                        and Industrial
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Mechanical Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Design and
                                                                Manufacturing
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        BE/B. Tech degree in
                                                        Mechanical
                                                        Engineering/Aerospace
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Mechanical
                                                        Engineering/Aerospace
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Mechanical Engineering
                                                    </td>
                                                    <td>
                                                        <ul>
                                                            <li>
                                                                Thermal
                                                                Engineering and
                                                                Energy systems
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table> */}
                                        {/* <p>
                                            <b>For GATE qualified candidates</b>
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                Bachelor’s degree in
                                                Engineering/Technology in a
                                                suitable discipline as in the
                                                above table from Educational
                                                Institutions approved by
                                                AICTE/Government.
                                            </li>
                                            <li>
                                                Candidates must have qualified
                                                in GATE 2023, 2022, or 2021 in a
                                                suitable GATE paper as in the
                                                above table.
                                            </li>
                                            <li>
                                                Candidates yet to appear or have
                                                appeared in the final
                                                examination for the qualifying
                                                degree specified as specified
                                                above and who are likely to
                                                complete the requirements for
                                                the qualifying degree by July
                                                2023.
                                            </li>
                                        </ul>
                                        <p>
                                            <b>For IIT Graduates</b>
                                        </p>
                                        <p>
                                            Candidates with B.Tech degree from
                                            IITs who satisfy the following
                                            conditions can apply without a valid
                                            GATE score.
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                Candidates graduating/graduated
                                                from IITs with B.Tech. degree in
                                                a suitable discipline as in the
                                                above table.
                                            </li>
                                            <li>
                                                Candidates must have CGPA of 8.0
                                                (7.5 for SC/ST) and above in the
                                                B.Tech. degree.
                                            </li>
                                        </ul> */}
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Fiancial  Assistance*/}

                        <div>
                            {financialOpen && (
                                <Fade in={financialOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Financial Assistance
                                        </h4>
                                        <p><b>
                                        IIT Tirupati does not offer any financial assistance to international students. However, applicants can explore the following links for financial assistance.
                                        </b></p>
                                        <ul className="myulcustarrow">
                                           {/*} <li> Study in India - (SII) -  <Link to="https://www.studyinindia.gov.in" target="_blank" className="c-link"> https://www.studyinindia.gov.in</Link></li>
                                            <li>Indian Council for Cultural Relations - (ICCR) - <Link to="http://a2ascholarships.iccr.gov.in" target="_blank" className="c-link">http://a2ascholarships.iccr.gov.in </Link></li>*/}
                                            {/* <li>
                                            For students from Nepal: Dr. Homi Jahangir Bhaba Scholarship for ME/M.Tech students (HJBSS) - <Link to="https://www.cgibirgunj.gov.in/page/advertisement-of-dr-homi-jahangir-bhabha-scholarship-scheme-2023-2024/" target="_blank" className="c-link">https://www.cgibirgunj.gov.in/page/advertisement-of-dr-homi-jahangir-bhabha-scholarship-scheme-2023-2024/
                                            </Link></li> */}
                                            <li>
                                            Study in India - <Link to="https://studyinindia.gov.in/" target="_blank" className="c-link">https://studyinindia.gov.in/
                                            </Link></li>
                                            </ul>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Section*/}

                        {/* <div>
                            {sectionOpen && (
                                <Fade in={sectionOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Selection Procedure
                                        </h4>
                                        <p>
                                            The selection committee will call
                                            eligible candidates based on the
                                            minimum eligibility requirements and
                                            additional screening criteria for a
                                            written test (if any) and interview.
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div> */}

                        {/*Documents*/}

                        <div>
                            {documentsOpen && (
                                <Fade in={documentsOpen}>
                                    <div>
                                    <h3 className="mb-4"> For Half-Time Teaching Assistantship (HTTA) Candidates:</h3>
                                        <h4 className="mb-4">
                                            Original Documents to be submitted for Verification:
                                        </h4>
                                        <p>
                                            <b>At the time of admission:</b>
                                        </p>
                                        <p>
                                        Self-attested copies of the following documents must be submitted at the time of admission. 
                                        </p>

                                        <ul className="myulcustarrow">
                                            <li>Copy of application</li>
                                            <li>Offer of admission.</li>
                                            <li>
                                            Birth Certificate / SSC / SSLC certifcate as proof of Name and Date of birth
                                            </li>
                                            <li>
                                            Any valid government ID proof such as Aadhaar, PAN, Passport, Driving License, etc. {" "}
                                            </li>
                                            <li>
                                            Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                            </li>
                                            <li>
                                            Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                            </li>
                                            <li>
                                            Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.
                                            </li>
                                            <li>
                                            Copy of valid GATE score (if applicable).
                                            </li>
                                        </ul>
                                        <h5 className="text-teal">
                                        Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
                                        </h5>


                                        <h4 className="mb-5 mt-5">For Sponsored candidates (Non-HTTA)Candidates: </h4>
                                        <ul className="myulcustarrow">
                                            <li> Offer of admission.</li>
                                            <li> 10th Certificate</li>
                                            <li> 12th / Diploma / Equivalent Certificate </li>
                                            <li> Essential Qualifying Degree Certificate</li>
                                            <li> GATE scorecard, if applicable</li>
                                            <li> Associate membership certificate, if applicable </li>
                                            <li> Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.</li>
                                            <li> Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.</li>
                                        </ul>

                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Section*/}

                        <div>
                            {feesOpen && (
                                <Fade in={feesOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Fees
                                        </h4>
                                        <p>
                                        	The tuition and hostel fees for the current semester can be found by clicking on the following{" "}
                                            <Link
                                                to="/fee-structure"
                                                className="c-link"
                                            >
                                                link
                                            </Link> Please note that an international student fee of INR 50,000/year will be applicable.
                                        </p>
                                        <p>Please note that the fee is subject to revision for the next semester.</p>
                                    </div>
                                </Fade>
                            )}
                        </div>
                        {/*Apply Online*/}

                        <div>
                            {applyonlineOpen && (
                                <Fade in={applyonlineOpen}>
                                    <div>
                                         <h5 className="mb-4">Apply Online : 
                                      

                                            <Link
                                                to="https://iittp.plumerp.co.in/prod/iittirupati/mtechapplication" target="_blank"
                                                
                                                className="c-link">
                                                <b className="text-maroon"> Click here</b>
                                            </Link>

                                        </h5> 

                                      {/*  <h5 className="mb-4">For GATE qualified/IIT Graduates (HTTA candidates) :


                                            <Link to="#" className="c-link">
                                                <b className="text-maroon">Will be updated soon..</b>
                                            </Link>

                                        </h5> 

                                        <h5 className="mb-4">For Sponsored (Non-HTTA candidates)  :


                                            <Link
                                                to="#"                                                
                                                className="c-link">
                                                <b className="text-maroon">Will be updated soon..</b>
                                            </Link>

                                        </h5> */}

                                        

                                    
                                    </div>
                                </Fade>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default MtechInternational_AdmissionELe;
